import { render, staticRenderFns } from "./Ibox.vue?vue&type=template&id=65c6ed9c&"
import script from "./Ibox.vue?vue&type=script&lang=js&"
export * from "./Ibox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports